import { Action } from '@ngrx/store';

export const PRODUCT_DETAIL_RESET_STATE = '[CustomProduct] Product Detail Reset State';

export class ProductDetailResetState implements Action {
  readonly type = PRODUCT_DETAIL_RESET_STATE;
}

export type ProductActions = ProductDetailResetState;
